import { Text, type TextProps } from "@chakra-ui/react";

export const Copyright = (props: TextProps) => (
  <Text {...props}>© {new Date().getFullYear()} Umami</Text>
);
